import { render, staticRenderFns } from "./UpdateIssuerCards.vue?vue&type=template&id=585ec462"
import script from "./UpdateIssuerCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpdateIssuerCards.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/cards/locales/i18n-card-dialogs.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2Fissuers%2Fchildren%2FUpdateIssuerCards.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports